import { Button, Divider, TextField, Box, FormControl, Grid, Stack, InputAdornment, Dialog, DialogTitle, DialogActions, Backdrop, DialogContent } from "@mui/material";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { DemoItem } from '@mui/x-date-pickers/internals/demo';
import { CalendarIcon } from '@mui/x-date-pickers/icons';
import classes from "../ParticipanteClasess.css";
import * as React from 'react';
import dayjs from 'dayjs';
import { useMediaQuery } from '@mui/material';

import 'dayjs/locale/es'; // Importa el archivo de localización para español

export default function Aval2Precargado({ identidad, nombres, apellidos, nacimiento, profesion, vivienda, barrio, calle, ave, casa, ciudad,
    departamento, estado, referenciadomicilio, fijo, movil, correo, dependencia, ramo, telefonolaboral, barriolaboral, avenidalaboral,
    callelaboral, casalaboral, ciudadlaboral, departamentolaboral, sueldomensual, otrosingresos, sueldoneto, puesto, tiempolaborarA,
    tiempolaborarM, icono, handleDescargar, openAval2, closeAval2, pdfUrlAval2 }) {
    const isMobile = useMediaQuery('(max-width:820px)'); // Detectar si es una pantalla móvil

    return (
        <>

            <Box marginTop={3}>
                <h3>IDENTIDAD DEL AVAL 2 EN FORMATO {isMobile ? "IMÁGENES" : "PDF"}</h3>
                <Box display="flex" alignItems="center" justifyContent="center">
                    <Box
                        style={{
                            padding: '50px',
                            width: isMobile ? '300px' : '700px',
                            textAlign: 'center',
                            borderColor: 'var(--color-gray-500)',
                            borderRadius: 5,
                            borderWidth: 5,
                            borderStyle: 'dashed',
                        }}
                    >
                        <img src={icono} alt="Download PDF Icon" style={{ width: 75, height: 77, color: 'var(--color-gray-500)' }} />
                        <br />
                        <Button
                            variant="contained"
                            onClick={handleDescargar}
                            color="primary"
                            style={{ marginTop: '10px', backgroundColor: 'var(--color-surface-muted)' }}
                        >
                            Ver Archivo {isMobile ? "Imágenes" : "PDF"}
                        </Button>
                        <p>Haz clic en el botón para visualizar la identidad del aval 2 en {isMobile ? "imágenes" : "PDF"}</p>
                        <Backdrop open={openAval2} onClick={closeAval2} style={{ zIndex: 1 }}>
                            <Dialog
                                open={openAval2}
                                onClose={closeAval2}
                                maxWidth="md"
                                fullWidth
                            >
                                <DialogTitle textAlign={'center'}>Identidad Del Aval 2</DialogTitle>
                                <DialogContent>
                                    {isMobile ? (
                                        // Mostrar imágenes si es móvil
                                        pdfUrlAval2 && pdfUrlAval2.map((base64Image, index) => (
                                            <img key={index} src={`data:image/png;base64,${base64Image}`} alt={`Aval2DNI ${index + 1}`} style={{ width: '100%', marginBottom: '10px' }} />
                                        ))
                                    ) : (
                                        // Mostrar PDF si es desktop
                                        pdfUrlAval2 && (
                                            <iframe
                                                src={pdfUrlAval2}
                                                width="100%"
                                                height="450px"
                                                style={{ border: 'none' }}
                                            />
                                        )
                                    )}
                                </DialogContent>
                            </Dialog>
                        </Backdrop>
                    </Box>
                </Box>
            </Box>
            <Divider style={{ marginTop: 5 }} />
        </>
    );
}


